import { api, throwApiError } from "../../api/api";

export type EvaluationQuestionType =
  | "BOOLEAN"
  | "SCALE"
  | "TEXT"
  | "SINGLE_CHOICE"
  | "MULTI_CHOICE"
  | string;

export type CreateEvaluationQuestionRequest = {
  type: EvaluationQuestionType;
  prompt: string;
  required?: boolean;
  order: number;
  dimension?: string;
  minValue?: number;
  maxValue?: number;
};

export type UpdateEvaluationQuestionRequest = {
  type?: EvaluationQuestionType;
  prompt?: string;
  required?: boolean;
  order?: number;
  dimension?: string;
  minValue?: number;
  maxValue?: number;
};

export type CreateEvaluationQuestionOptionRequest = {
  label: string;
  value?: string;
  order: number;
};

export type UpdateEvaluationQuestionOptionRequest = {
  label?: string;
  value?: string;
  order?: number;
};

export type EvaluationQuestionOption = {
  id: string;
  questionId: string;
  label: string;
  value?: string | null;
  order: number;
};

export type EvaluationQuestion = {
  id: string;
  formId: string;
  type: EvaluationQuestionType;
  prompt: string;
  required: boolean;
  order: number;
  dimension?: string | null;
  minValue?: number | null;
  maxValue?: number | null;
  archivedAt?: string | null;
  options?: EvaluationQuestionOption[];
  createdAt: string;
  updatedAt: string;
};

export const createEvaluationFormQuestionApi = async (
  formId: string,
  dto: CreateEvaluationQuestionRequest
): Promise<EvaluationQuestion> => {
  try {
    const { data } = await api.post<EvaluationQuestion>(
      `/evaluation-forms/${formId}/questions`,
      dto
    );
    return data;
  } catch (error) {
    throwApiError(error, "Erro ao criar pergunta no formulário de avaliação.");
    throw error;
  }
};

export const updateEvaluationFormQuestionApi = async (
  formId: string,
  questionId: string,
  dto: UpdateEvaluationQuestionRequest
): Promise<EvaluationQuestion> => {
  try {
    const { data } = await api.patch<EvaluationQuestion>(
      `/evaluation-forms/${formId}/questions/${questionId}`,
      dto
    );
    return data;
  } catch (error) {
    throwApiError(error, "Erro ao atualizar pergunta do formulário de avaliação.");
    throw error;
  }
};

export const archiveEvaluationFormQuestionApi = async (
  formId: string,
  questionId: string
): Promise<EvaluationQuestion> => {
  try {
    const { data } = await api.delete<EvaluationQuestion>(
      `/evaluation-forms/${formId}/questions/${questionId}`
    );
    return data;
  } catch (error) {
    throwApiError(error, "Erro ao arquivar pergunta do formulário de avaliação.");
    throw error;
  }
};

export const createEvaluationQuestionOptionApi = async (
  formId: string,
  questionId: string,
  dto: CreateEvaluationQuestionOptionRequest
): Promise<EvaluationQuestionOption> => {
  try {
    const { data } = await api.post<EvaluationQuestionOption>(
      `/evaluation-forms/${formId}/questions/${questionId}/options`,
      dto
    );
    return data;
  } catch (error) {
    throwApiError(error, "Erro ao criar opção de resposta da pergunta.");
    throw error;
  }
};

export const updateEvaluationQuestionOptionApi = async (
  formId: string,
  questionId: string,
  optionId: string,
  dto: UpdateEvaluationQuestionOptionRequest
): Promise<EvaluationQuestionOption> => {
  try {
    const { data } = await api.patch<EvaluationQuestionOption>(
      `/evaluation-forms/${formId}/questions/${questionId}/options/${optionId}`,
      dto
    );
    return data;
  } catch (error) {
    throwApiError(error, "Erro ao atualizar opção de resposta da pergunta.");
    throw error;
  }
};

export const deleteEvaluationQuestionOptionApi = async (
  formId: string,
  questionId: string,
  optionId: string
): Promise<EvaluationQuestionOption> => {
  try {
    const { data } = await api.delete<EvaluationQuestionOption>(
      `/evaluation-forms/${formId}/questions/${questionId}/options/${optionId}`
    );
    return data;
  } catch (error) {
    throwApiError(error, "Erro ao remover opção de resposta da pergunta.");
    throw error;
  }
};
